export const INDIVIDUALS_EXPORT_HEADS = [
  { id: "id", label: "ID" },
  { id: "clinicalRecord", label: "Prontuário" },
  { id: "commonName", label: "Nome Comum" },
  { id: "ufuName", label: "Nome UFU" },
  { id: "situation", label: "Situação" },
  { id: "gender", label: "Sexo" },
  { id: "markingType", label: "Tipo de Marcação" },
  { id: "marking", label: "Marcação" },
  { id: "taxonomicGroupId", label: "Grupo Taxonômico ID" },
  { id: "hasGPS", label: "Possui GPS" },
  { id: "lastLocationLatitude", label: "Última Latitude" },
  { id: "lastLocationLongitude", label: "Última Longitude" },
  { id: "lastLocationDate", label: "Data Última Localização" },
  { id: "lastReleaseDate", label: "Data Última Soltura" },
  { id: "lastEntranceDate", label: "Data Última Entrada" },
  { id: "observations", label: "Observações" },
  { id: "createdAt", label: "Criado em" },
  { id: "updatedAt", label: "Atualizado em" },
];
